import React, { useEffect } from "react";
// ANT DESIGN COMPONENTS
import { Modal, Spin } from "antd";
// REDUX
import { useDispatch, useSelector } from "react-redux";
import { useDeleteServerMutation } from "../../../redux/servers/serverAPI";
// AUTHORIZATION
import GETJwtToken from "../../../redux/authentication/authentication";
import { updateOpenModalDeleteServer } from "../../../redux/servers/serverSlice";
// COMPONENTS
import ModalDeleteItemContainer from "../../components/modal/ModalDeleteItemContainer";
import GlobalAlert2 from "../../home/GlobalAlert2";
// INTERFACES
import { RootState } from "../../../app/store";
// UTILS
import { uuidToString } from "../../../utils/uuid";

function ServersDeleteModal() {
  // ************************************************ */
  // GLOBAL VARIABLES ******************************* */
  const dispatch = useDispatch();

  // ************************************************ */
  // USE STATE VARIABLES **************************** */

  // ************************************************ */
  // REDUX SLICE VARIABLES ************************** */
  const { server, openModalDeleteServer } = useSelector((state: RootState) => state.server);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [triggerDeleteItem, { isLoading, isSuccess, isError, error, reset }] =
    useDeleteServerMutation();

  // ************************************************ */
  // FUNCTIONS ************************************** */
  const onClickClose = () => {
    dispatch(updateOpenModalDeleteServer(false));
  };

  const onClickDelete = async () => {
    const token = await GETJwtToken();
    triggerDeleteItem({ id: uuidToString(server.id), token });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    if (openModalDeleteServer) {
      reset();
    }
  }, [openModalDeleteServer]);

  useEffect(() => {
    if (isSuccess) {
      dispatch(updateOpenModalDeleteServer(false));
    }
  }, [isSuccess]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Modal
      onOk={onClickClose}
      closable={false}
      onCancel={onClickClose}
      open={openModalDeleteServer}
      footer={null}
    >
      <Spin spinning={isLoading}>
        <ModalDeleteItemContainer
          name={server.name}
          onClickDelete={onClickDelete}
          onClickClose={onClickClose}
        />
      </Spin>
      {/** ---------------------------------------------------- */}
      {/** GLOBAL ALERT */}
      <GlobalAlert2
        isError={isError}
        isSuccess={isSuccess}
        requestType="DELETE"
        error={error}
        name="Server"
      />
    </Modal>
  );
}

export default ServersDeleteModal;
